module.exports = __webpack_public_path__ + "img/boat8.155c7386.jpg";